/* Braymont multi-buy selector: the existing native Shopify product form owns Add to Cart. */
(function(){
  function init(root){
    if(root.dataset.bmInitialized==='1')return;
    root.dataset.bmInitialized='1';
    const dataEl=root.querySelector('[data-bm-bundle-product]');
    let main;
    try{main=JSON.parse(dataEl.textContent)}catch{return}
    const money=n=>new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(n/100);
    const esc=x=>String(x??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const tierEls=[...root.querySelectorAll('[data-bm-tier]')];
    const config=root.querySelector('[data-bm-config]');
    // Shared configuration moves INSIDE the selected offer card, never below all cards.
    tierEls.forEach(btn=>{
      const shell=document.createElement('div');
      shell.className='bm-bundle__option';
      btn.parentNode.insertBefore(shell,btn);
      shell.appendChild(btn);
    });
    const state={tab:'same',tier:2,choices:[main.variants.find(v=>v.available)||main.variants[0],null,null],sameChoices:null,mixChoices:null,related:[],picked:[null,null],searching:false};
    // Shopify automatic Basic discounts: 2 pieces 15%, 3+ pieces 25% on the entire cart.
    // These tiers are mutually exclusive, and shipping discounts are combinable.
    const orderDiscount = quantity => quantity>=3?0.25:quantity>=2?0.15:0;
    function getEntries(tier=state.tier){
      let arr=[];
      for(let i=0;i<tier;i++){
        if(i===0||state.tab==='same'){const v=state.choices[i]||state.choices[0];arr.push({p:main,v})}
        else{const p=state.picked[i-1];arr.push({p,v:p?state.choices[i]:null})}
      }
      return arr;
    }
    function compute(tier=state.tier){
      const entries=getEntries(tier);
      const original=entries.reduce((n,x)=>n+(x.v?.price||0),0);
      const saved=entries.every(x=>x.p&&x.v&&x.v.available) ? Math.round(original*orderDiscount(tier)) : 0;
      return {entries,original,saved,total:original-saved,complete:entries.every(x=>x.p&&x.v&&x.v.available)};
    }
    function offerText(n){
      if(n===1)return 'Standard price';
      return n===2?'Save 15% on your 2-piece order':'Save 25% on your 3-piece order';
    }
    function update(){
      root.querySelectorAll('[data-bm-tab]').forEach(b=>{const active=b.dataset.bmTab===state.tab;b.classList.toggle('is-current',active);b.setAttribute('aria-selected',String(active))});
      tierEls.forEach(el=>{let current=+el.dataset.bmTier===state.tier;el.classList.toggle('is-current',current);el.setAttribute('aria-checked',String(current));el.parentElement.classList.toggle('is-current',current)});
      const selectedTier=root.querySelector('[data-bm-tier="'+state.tier+'"]');
      if(selectedTier&&config.parentNode!==selectedTier.parentNode)selectedTier.parentNode.appendChild(config);
      for(const n of [1,2,3]){const a=compute(n);const p=root.querySelector('[data-bm-price-'+n+']');if(p)p.textContent=a.complete?money(a.total):'Choose pieces';const orig=root.querySelector('[data-bm-original-'+n+']');if(orig)orig.textContent=a.complete?money(a.original):'';const save=root.querySelector('[data-bm-save-'+n+']');if(save)save.textContent=n===2?'15% OFF':n===3?'25% OFF':'';const copy=root.querySelector('[data-bm-copy-'+n+']');if(copy)copy.textContent=offerText(n)}
      const c=compute();
      const shippingLabel=root.querySelector('[data-bm-shipping-label]');
      if(shippingLabel)shippingLabel.textContent=state.tier>=3?'FREE UK RUSH SHIPPING — 3 PIECES':'FREE UK STANDARD DELIVERY';
      root.querySelector('[data-bm-original-total]').textContent=c.complete?money(c.original):'—';
      root.querySelector('[data-bm-discount-total]').textContent=c.complete?'−'+money(c.saved):'—';
      root.querySelector('[data-bm-final-total]').textContent=c.complete?money(c.total):'Choose pieces';
      const msg=root.querySelector('[data-bm-message]');
      if(msg) msg.textContent=state.tab==='mix'&&!c.complete
        ?'Choose a different complementary product for each slot and select its colour and size.'
        :c.complete?'Automatic savings apply in the bag.':'Choose all pieces and available sizes.';
    }
    function optionsRow(p,variant,index){
      if(!p)return '<div class="bm-bundle__line"><span></span><span>Choose a style above</span></div>';
      const values=variant?.options||p.variants[0]?.options||[];
      let selects=(p.options||[]).map((name,k)=>{
        const uniq=[...new Set(p.variants.filter(v=>v.available).map(v=>v.options[k]))];
        return '<label>'+esc(name)+'<select data-bm-select="'+index+'" data-opt="'+k+'">'+uniq.map(x=>'<option value="'+esc(x)+'" '+(values[k]===x?'selected':'')+'>'+esc(x)+'</option>').join('')+'</select></label>';
      }).join('');
      const image=p.image||p.featured_image||p.images?.[0]||'';
      const src=typeof image==='string'?image:(image?.src||image?.url||'');
      return '<div class="bm-bundle__line">'+(src?'<img class="bm-bundle__thumb" src="'+esc(src)+'" loading="lazy" width="40" height="50" alt="">':'<span></span>')+'<div class="bm-bundle__line-info"><span class="bm-bundle__line-title">Piece '+(index+1)+' · '+esc(p.title)+'</span><div class="bm-bundle__selectors">'+selects+'</div></div></div>';
    }
    function renderRows(){
      const target=root.querySelector('[data-bm-rows]');
      if(!target)return;
      let html='';
      const count=state.tier;
      const labels=['FIRST','SECOND','THIRD'];
      function candidateList(i){
        const exclude=new Set([main.id,state.picked[1-(i-1)]?.id].filter(Boolean));
        // Different curated groups for piece 2 and piece 3.
        const start=i===1?0:3;
        const primary=state.related.slice(start,start+3).filter(x=>!exclude.has(x.id));
        const pool=[...primary,...state.related.filter(x=>!exclude.has(x.id)&&!primary.some(y=>y.id===x.id))];
        const suggestions=pool.slice(0,3);
        return '<p class="bm-bundle__suggest-title">0'+(i+1)+' — Choose your '+labels[i].toLowerCase()+' piece</p>'+
          '<div class="bm-bundle__choices">'+suggestions.map(p=>{
            const active=state.picked[i-1]?.id===p.id;
            const src=p.image||p.featured_image||p.images?.[0]||'';
            const thumb=src?'<img src="'+esc(src)+'" alt="" width="68" height="86" loading="lazy">':'';
            const amount=p.variants.find(v=>v.available)?.price||p.price||0;
            return '<button type="button" class="bm-bundle__choice" data-bm-pick-index="'+(i-1)+'" data-bm-pick="'+esc(p.handle)+'" aria-pressed="'+active+'">'+thumb+'<span class="bm-bundle__choice-text"><strong>'+esc(p.title)+'</strong><small>From '+money(amount)+'</small></span><span class="bm-bundle__choice-check" aria-hidden="true">'+(active?'✓':'○')+'</span></button>';
          }).join('')+'</div>'+
          (!state.related.length?'<p class="bm-bundle__empty">'+(state.searching?'Finding complementary styles…':'No complementary styles are available right now.')+'</p>':'');
      }
      for(let i=0;i<count;i++){
        if(state.tab==='mix'&&i>0){
          html+=candidateList(i);
          if(state.picked[i-1])html+=optionsRow(state.picked[i-1],state.choices[i],i);
        }else{
          html+=optionsRow(main,state.choices[i]||state.choices[0],i);
        }
      }
      target.innerHTML=html;
    }
    async function loadRelated(){
      if(state.related.length||state.searching)return;
      state.searching=true;
      const name=(main.product_type+' '+main.title).toLowerCase();
      const terms=/coat|jacket|puffer/.test(name)?['cardigan','sweater','knitwear']:/dress|skirt/.test(name)?['cardigan','jacket','blouse']:/shirt|blouse/.test(name)?['trousers','cardigan','knitwear']:/trouser|pants/.test(name)?['sweater','shirt','cardigan']:['trousers','cardigan','shirt'];
      const found=new Map();
      for(const term of terms){
        try{
          const r=await fetch('/search/suggest.json?q='+encodeURIComponent(term)+'&resources[type]=product&resources[limit]=10',{credentials:'same-origin'});
          if(!r.ok)continue;
          const j=await r.json();
          let perCategory=0;
          for(const p of j.resources?.results?.products||[]){
            if(perCategory>=3)break;
            if(p.id===main.id||!(/^[a-z0-9-]+$/i.test(p.handle))||found.has(p.handle))continue;
            found.set(p.handle,p);perCategory++;
          }
        }catch(e){console.warn('Braymont bundle recommendation lookup',e)}
        // Always check complementary categories, not only the first matching term.
      }
      for(const p of [...found.values()].slice(0,9)){
        try{
          const r=await fetch('/products/'+p.handle+'.js',{credentials:'same-origin'});
          if(!r.ok)continue;
          const detail=await r.json();
          if(!detail.available||detail.id===main.id)continue;
          detail.image=typeof detail.featured_image==='string'?detail.featured_image:(detail.featured_image?.src||p.featured_image?.url||'');
          state.related.push(detail);
        }catch(e){}
      }
      // Do not silently choose secondary items for the customer.
      state.picked=[null,null];
      if(state.tab==='mix'){
        state.choices[1]=null;
        state.choices[2]=null;
      }
      state.mixChoices=[state.choices[0],null,null];
      state.searching=false;
      renderRows();update();
    }
    root.addEventListener('click',async e=>{
      const tab=e.target.closest('[data-bm-tab]');if(tab){
        const next=tab.dataset.bmTab;
        if(next!==state.tab){
          if(state.tab==='same')state.sameChoices=[...state.choices];else state.mixChoices=[...state.choices];
          state.tab=next;
          state.choices=[...(next==='same'?(state.sameChoices||[state.choices[0],null,null]):(state.mixChoices||[state.choices[0],null,null]))];
        }
        if(state.tab==='mix')loadRelated();
        renderRows();update();return;
      }
      const tier=e.target.closest('[data-bm-tier]');if(tier){state.tier=Number(tier.dataset.bmTier);renderRows();update();return}
      const pick=e.target.closest('[data-bm-pick]');if(pick){
        const index=+pick.dataset.bmPickIndex;
        const p=state.related.find(x=>x.handle===pick.dataset.bmPick);
        if(!p||state.picked[1-index]?.id===p.id||p.id===main.id)return;
        state.picked[index]=p;state.choices[index+1]=p.variants.find(v=>v.available)||null;renderRows();update();return;
      }
    });
    root.addEventListener('change',e=>{
      const sel=e.target.closest('[data-bm-select]');if(!sel)return;
      const i=+sel.dataset.bmSelect;
      const p=i===0||state.tab==='same'?main:state.picked[i-1];
      if(!p)return;
      const group=[...root.querySelectorAll('[data-bm-select="'+i+'"]')];
      const opts=(p.options||[]).map((_,k)=>group.find(s=>+s.dataset.opt===k)?.value);
      let found=p.variants.find(v=>v.available&&v.options.every((x,k)=>x===opts[k]));
      if(!found){root.querySelector('[data-bm-message]').textContent='This combination is currently unavailable.';return}
      state.choices[i]=found;renderRows();update();
    });
    // Expose validated selections to the native <product-form> in this product section.
    // No secondary button, no redirect; the native cart drawer handles Shopify Ajax.
    root.braymontGetItems=()=>{
      const selected=compute();
      if(!selected.complete){
        const message=state.tab==='mix'
          ?'Please choose different products for each piece and select all available options.'
          :'Please select an available colour and size for each piece.';
        const status=root.querySelector('[data-bm-message]');
        if(status)status.textContent=message;
        return {error:message};
      }
      return {
        items:selected.entries.map((entry,index)=>({
          id:Number(entry.v.id),
          quantity:1,
          properties:{
            _braymont_bundle_tier:String(state.tier),
            _braymont_bundle_slot:String(index+1),
            _braymont_bundle_mode:state.tab
          }
        }))
      };
    };
    // Real, shared stock REVIEW deadline: no offer-expiry claim, no auto restart.
    // The owner may extend the time in the Theme Editor after checking external stock records.
    const stockReview=root.querySelector('[data-bm-stock-review]');
    if(stockReview){
      const clock=stockReview.querySelector('[data-bm-stock-clock]');
      const due=stockReview.querySelector('[data-bm-stock-due]');
      const duration=Number(stockReview.dataset.durationHours);
      const start=Date.parse(stockReview.dataset.startUtc||'');
      const deadline=Number.isFinite(start)&&Number.isInteger(duration)&&duration>0
        ?start+duration*3600000:NaN;
      const pad=v=>String(v).padStart(2,'0');
      let handle;
      const tick=()=>{
        if(!root.isConnected){if(handle)clearInterval(handle);return;}
        if(!clock)return;
        if(!Number.isFinite(deadline)){
          clock.textContent='—';
          if(due){due.textContent='Please check the configured review start time.';due.hidden=false;}
          if(handle)clearInterval(handle);
          return;
        }
        const secs=Math.max(0,Math.ceil((deadline-Date.now())/1000));
        if(secs===0){
          clock.hidden=true;
          if(due){due.textContent=stockReview.dataset.dueLabel||'Stock review due';due.hidden=false;}
          if(handle)clearInterval(handle);
          return;
        }
        const hours=Math.floor(secs/3600);
        const mins=Math.floor(secs%3600/60);
        const seconds=secs%60;
        clock.textContent=pad(hours)+':'+pad(mins)+':'+pad(seconds);
        clock.dateTime=new Date(deadline).toISOString();
      };
      if(clock){tick();if(!clock.hidden)handle=setInterval(tick,1000);}
    }
    const defaultV=main.variants.find(v=>v.available)||main.variants[0];
    state.choices[0]=defaultV;
    state.choices[1]=main.variants.find(v=>v.available&&v.options[0]!==defaultV.options[0])||defaultV;
    state.choices[2]=main.variants.find(v=>v.available&&v.id!==state.choices[1].id&&v.id!==defaultV.id)||defaultV;
    state.sameChoices=[...state.choices];
    renderRows();update();
  }
  function boot(){document.querySelectorAll('[data-bm-bundle]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
})();